import React from 'react';

import {
  Divider,
  List,
} from '@mui/material';
import ReactMarkdown from 'react-markdown';

import type { EntityDataPubNotNullType } from '@/domain/entityPub';
import type { ContentJson } from '@/domain/news/service/entity/contentEntity';
import type { SentNewsJsonPub, SentNewsJsonPvt } from '@/domain/news/service/entity/sentNewsEntity';

import AttachmentDownloadButton from '@/components/AttachmentDownloadButton';
import CustomListItem from '@/components/CustomListItem';
import { Category } from '@/domain/news/service/entity/valueObjects/category';
import { Title } from '@/domain/news/service/entity/valueObjects/title';

const NewsContent: React.FC<{
  /** データ */
  data: {
    /** コンテンツ */
    content: ContentJson,
    /** インフォ */
    info: EntityDataPubNotNullType<SentNewsJsonPvt, SentNewsJsonPub>
  },
}> = ({ data }) => (
  <>
    <List>
      <CustomListItem name={Title.label} content={data.info.data.title} />
      <CustomListItem name={Category.label} content={data.info.data.category} />
    </List>
    <Divider style={{ marginBottom: '10px' }} />
    <div>
      <p>
        <span>添付ファイル：</span>
        {data.content.attachments.length > 0 ? (
          <AttachmentDownloadButton attachment={data.content.attachments[0]} />
        ) : (
          <span>なし</span>
        )}
      </p>
    </div>
    <Divider style={{ marginBottom: '10px' }} />
    <div className="container">
      <ReactMarkdown
        components={{

          img: (e) => {
            if (e.src) {
              const index = parseInt(e.src, 10);
              if (!Number.isNaN(index) && index >= 0 && index < data.content.images.length) {
                return <img alt={e.alt} src={data.content.images[index]} />;
              }
            }
            return <img alt={e.alt} src={e.src} />;
          },
        }}
      >
        {data.content.text}
      </ReactMarkdown>
    </div>
  </>
);

export default NewsContent;
